export default defineNuxtPlugin((app) => {
    const initTime = setTimeout(() => {
        const script = document.createElement('script')
        script.innerHTML = 'function loadScript(a){var b=document.getElementsByTagName("head")[0],c=document.createElement("script");c.type="text/javascript",c.src="https://tracker.metricool.com/resources/be.js",c.onreadystatechange=a,c.onload=a,b.appendChild(c)}loadScript(function(){beTracker.t({hash:"fe82f5b6c3c5bddf83542175083ddae6"})});'
        script.async = true
        document.getElementsByTagName('head')[0].appendChild(script)
        clearTimeout(initTime)
    }, 5000)
})
